import React, { createContext, useContext, useState, useMemo } from 'react';

export type RecordsTab = 'dashboard' | 'database' | 'archive' | 'trends';

const STORAGE_KEY = 'kc_recordsTab';
const VALID_TABS: RecordsTab[] = ['dashboard', 'database', 'archive', 'trends'];

function getSavedTab(): RecordsTab {
  const saved = localStorage.getItem(STORAGE_KEY);
  return VALID_TABS.includes(saved as RecordsTab) ? (saved as RecordsTab) : 'dashboard';
}

interface RecordsTabContextValue {
  tab: RecordsTab;
  setTab: (tab: RecordsTab) => void;
}

const RecordsTabContext = createContext<RecordsTabContextValue | null>(null);

export function RecordsTabProvider({ children }: { children: React.ReactNode }) {
  const [tab, setTabState] = useState<RecordsTab>(getSavedTab);
  const setTab = (t: RecordsTab) => {
    localStorage.setItem(STORAGE_KEY, t);
    setTabState(t);
  };
  const value = useMemo(() => ({ tab, setTab }), [tab]);
  return (
    <RecordsTabContext.Provider value={value}>
      {children}
    </RecordsTabContext.Provider>
  );
}

export function useRecordsTab(): RecordsTabContextValue {
  const ctx = useContext(RecordsTabContext);
  if (!ctx) throw new Error('useRecordsTab must be used within RecordsTabProvider');
  return ctx;
}
